import { render, staticRenderFns } from "./ParallaxedSection.vue?vue&type=template&id=e75afa98&scoped=true"
import script from "./ParallaxedSection.vue?vue&type=script&lang=ts"
export * from "./ParallaxedSection.vue?vue&type=script&lang=ts"
import style0 from "./ParallaxedSection.vue?vue&type=style&index=0&id=e75afa98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e75afa98",
  null
  
)

export default component.exports